export enum ResidentAuthorizations {
  Visualization = 'ESTRAZIONE.RESID.QUERY',
}

export const ResidentExtraction = [ResidentAuthorizations.Visualization];

export const ResidentAuthorizationsList = [...ResidentExtraction];
